import React, { useState, useEffect } from 'react';
import { Container, Accordion, Button, Spinner, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Ad from './Ad';
function CategorySelection() {
  const [categories, setCategories] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = () => {
      if (window.subCategories) {
        setCategories(window.subCategories.data.categories);
        setLoading(false);
      }
    };

    if (!window.subCategories) {
      const script = document.createElement('script');
      script.src = 'https://small.fileditchstuff.me/s19/XWZufgannoAwvBuAZQgV.js';
      script.onload = loadCategories;
      document.body.appendChild(script);
    } else {
      loadCategories();
    }
  }, []);

  const handleCategorySelect = (title) => {
    navigate(`/nsfw_infinity_scroll?sub=${encodeURIComponent(title)}`);
  };

  const searchInElements = (elements, term) => {
    if (!elements) return false;
    return elements.some(item => {
      const titleMatch = item.title.toLowerCase().includes(term.toLowerCase());
      if (titleMatch) return true;
      if (item.elements) {
        return searchInElements(item.elements, term);
      }
      return false;
    });
  };

  const filterCategories = (categories, term) => {
    if (!term) return categories;
    
    return categories?.filter(category => {
      const titleMatch = category.title.toLowerCase().includes(term.toLowerCase());
      const elementsMatch = searchInElements(category.elements, term);
      return titleMatch || elementsMatch;
    });
  };

  const renderCategoryElements = (elements) => {
    if (!elements) return null;

    return elements.map((item, index) => {
      const matchesTerm = item.title.toLowerCase().includes(searchTerm.toLowerCase());
      const hasMatchingChildren = item.elements && searchInElements(item.elements, searchTerm);
      
      if (searchTerm && !matchesTerm && !hasMatchingChildren) {
        return null;
      }

      return (
        <div key={index}>
          {item.elements === null ? (
            <Button 
              variant="outline-light" 
              className="m-1"
              onClick={() => handleCategorySelect(item.title)}
            >
              {item.title}
            </Button>
          ) : (
            <Accordion className="mb-2">
              <Accordion.Item eventKey={item.title}>
                <Accordion.Header>{item.title}</Accordion.Header>
                <Accordion.Body>
                  {renderCategoryElements(item.elements)}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          )}
        </div>
      );
    }).filter(Boolean);
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="light" />
      </Container>
    );
  }

  const filteredCategories = filterCategories(categories, searchTerm);

  return (
    <Container className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Button variant="outline-primary" onClick={() => navigate('/')}>
          ← Home
        </Button>
        <h1 className="m-0">Select a Category</h1>
      </div>
      
      <Button 
        variant="primary" 
        className="mb-4 me-2"
        onClick={() => navigate('/nsfw_infinity_scroll')}
      >
        View All (Featured)
      </Button>
      
      <Form.Group className="mb-4">
        <Form.Control
          type="text"
          placeholder="Search categories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="bg-dark text-light"
        />
      </Form.Group>

      <Accordion data-bs-theme="dark">
        {filteredCategories?.map((category, index) => {
          const matchesTerm = category.title.toLowerCase().includes(searchTerm.toLowerCase());
          const hasMatchingChildren = searchInElements(category.elements, searchTerm);
          
          if (searchTerm && !matchesTerm && !hasMatchingChildren) {
            return null;
          }

          return (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>{category.title}</Accordion.Header>
              <Accordion.Body>
                {renderCategoryElements(category.elements)}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
      <div className="d-flex flex-column align-items-center">
        <Ad width={728} height={90} />
        <Ad width={468} height={60} />
        <Ad width={320} height={50} />
      </div>
    </Container>
  );
}

export default CategorySelection;
